import { Link } from "react-router-dom";
import { useState } from "react";

/**
 * @description VerificationProjectCard component, used to display the project cards in the verification page. Also used to display comments(pass isComment=true) in the comments section.
 * @param {*} facility
 * @param {*} link
 * @param {*} loading
 * @param {*} isComment
 * @returns
 */
export default function VerificationProjectCard({
  facility,
  link,
  loading,
  isComment = false,
}) {
  const [open, setOpen] = useState(true);

  return (
    <div className="flex flex-col items-start p-10 gap-6 w-[1042px] mb-3 max-w-[1042px] bg-gray-50 rounded-lg">
      {/* Header Section */}
      <div className="flex flex-row items-center justify-between w-full h-6">
        <div className="flex-1 min-w-0">
          <h3 className="text-[16px] font-medium text-gray-900 leading-6 truncate">
            Organizational Name - {facility?.facilityName || "Unknown Facility"}
          </h3>
        </div>
        <div className="flex items-center justify-end gap-3 w-[239px]">
          <div className="text-[16px] font-normal text-gray-900 text-right leading-5">
            {facility?.rangeStartDate && facility?.rangeEndDate
              ? `${facility.rangeStartDate} - ${facility.rangeEndDate}`
              : "Date range not specified"}
          </div>
          <button
            onClick={() => setOpen((prev) => !prev)}
            className="flex items-center justify-center w-10 h-10 cursor-pointer transform transition-transform"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`transform ${
                !open ? "rotate-180" : ""
              } transition-transform`}
            >
              <circle
                cx="12"
                cy="12"
                r="12"
                transform="matrix(1 0 0 -1 0 24)"
                fill="#D0D5DD"
              />
              <path
                d="M8.66683 13.3333L12.0002 10L15.3335 13.3333"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Expanded Content */}
      {open && (
        <>
          <div className="w-full border-t border-gray-300 mt-5 mb-5"></div>
          <div className="flex flex-row justify-between items-center w-full h-12 gap-6">
            <div className="flex flex-row items-center gap-6 flex-1 max-w-[849px]">
              <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
                <div className="text-[14px] font-normal text-gray-900 leading-5 w-full">
                  Total Project emission data:
                </div>
                <div className="text-[14px] font-medium text-gray-500 leading-5 mt-3 w-full">
                  {facility?.totalGHGEmission || "0.00"} tCO2e
                </div>
              </div>

              <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
                <div className="text-[14px] font-normal text-gray-900 leading-5 w-full">
                  Total Baseline emission data:
                </div>
                <div className="text-[14px] font-medium text-gray-500 leading-5 mt-3 w-full">
                  {facility?.quantifiedGHGEmissionsInBaselineScenario || "0.00"}{" "}
                  tCO2e
                </div>
              </div>

              <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
                <div className="text-[14px] font-normal text-gray-900 leading-5 w-full">
                  Total Energy consumption:
                </div>
                <div className="text-[14px] font-medium text-gray-500 leading-5 mt-3 w-full">
                  {facility?.energyConsumptionInKWh || "0.00"} kWh
                </div>
              </div>

              <div className="flex flex-col items-center gap-2 flex-1 min-w-0">
                <div className="text-[14px] font-normal text-gray-900 leading-5 w-full">
                  Reporting period:
                </div>
                <div className="text-[14px] font-medium text-gray-500 leading-5 mt-3 w-full capitalize">
                  {facility?.reportingPeriod || "Not specified"}
                </div>
              </div>
            </div>

            {isComment && (
              <button className="font-semibold text-[14px] text-[#038B47] underline">
                View Comment
              </button>
            )}

            <div className="flex items-center gap-3 w-[145px] h-[50px]">
              {loading ? (
                <div className="flex justify-center items-center w-full h-[50px] bg-gray-400 rounded-lg text-white font-semibold">
                  Loading...
                </div>
              ) : (
                <Link
                  to={link}
                  className="flex justify-center items-center gap-3 w-full h-[50px] text-[16px] px-4 bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg text-white font-semibold leading-6 hover:opacity-90 transition-opacity"
                >
                  Verify
                </Link>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
